import { Epic, ofType } from 'redux-observable';
import { from, of } from 'rxjs';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';
import { addNotification } from '../../../actions/ui';
import {
  DEFAULT_NOTIFICATION_CLOSE_TIMEOUT,
  NotificationTypeEnum,
} from '../../../actions/ui/types';
import {
  DOWNLOAD_REPORT_FAILURE,
  DOWNLOAD_REPORT_REQUEST,
} from '../../../actions/types';
import { downloadReport } from '../../../actions';
import { reportsCenterErrorCodes } from '../../../config/errorCodeMessages';

export const downloadReportEpic: Epic = (action$, state$, { api }) =>
  action$.pipe(
    ofType(DOWNLOAD_REPORT_REQUEST),
    switchMap((action) => {
      return from(
        api.reportsCenterService
          .downloadReport(action.payload?.downloadReportInput)
          .pipe(
            mergeMap((response) =>
              of(
                downloadReport.success({
                  ...(response || {}),
                  downloadType: action.payload.downloadType,
                  supportingDocumentKey: action.payload?.supportingDocumentKey,
                })
              )
            ),
            catchError((err) =>
              of(
                downloadReport.failure(err),
                addNotification({
                  type: NotificationTypeEnum.ERROR,
                  action: DOWNLOAD_REPORT_FAILURE,
                  body: err?.receivedException?.errorCode
                    ? reportsCenterErrorCodes[
                        err?.receivedException?.errorCode
                      ] ?? 'download_report_notifications.failure'
                    : 'download_report_notifications.failure',
                  timeout: DEFAULT_NOTIFICATION_CLOSE_TIMEOUT,
                })
              )
            )
          )
      );
    })
  );

export default downloadReportEpic;
